export default __webpack_public_path__ + "static/media/icon-previsional.2e508927.svg";